export default __webpack_public_path__ + "static/viinitie-banner-xmass-mobile.a513276b559c04c0540a2386de8dd425.webp";